/**
 * Heading Component for Puck Editor
 * 
 * Judul dengan berbagai level (H1-H6)
 */

import type { ComponentConfig } from '@measured/puck'

export interface HeadingProps {
  text: string
  level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  alignment: 'left' | 'center' | 'right'
  color: string
}

const levelClasses = {
  h1: 'text-4xl md:text-5xl font-bold',
  h2: 'text-3xl md:text-4xl font-bold',
  h3: 'text-2xl md:text-3xl font-semibold',
  h4: 'text-xl md:text-2xl font-semibold',
  h5: 'text-lg md:text-xl font-medium',
  h6: 'text-base md:text-lg font-medium',
}

const alignmentClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
}

export function Heading({ text, level, alignment, color }: HeadingProps) {
  const Tag = level

  return (
    <Tag
      className={`${levelClasses[level]} ${alignmentClasses[alignment]} mb-4`}
      style={{ color: color || undefined }}
    >
      {text}
    </Tag>
  )
}

export const HeadingConfig: ComponentConfig<HeadingProps> = {
  label: 'Judul',
  defaultProps: {
    text: 'Judul Halaman',
    level: 'h2',
    alignment: 'left',
    color: '',
  },
  fields: {
    text: {
      type: 'text',
      label: 'Teks',
    },
    level: {
      type: 'select',
      label: 'Level',
      options: [
        { label: 'H1 - Judul Utama', value: 'h1' },
        { label: 'H2 - Sub Judul', value: 'h2' },
        { label: 'H3 - Judul Seksi', value: 'h3' },
        { label: 'H4', value: 'h4' },
        { label: 'H5', value: 'h5' },
        { label: 'H6', value: 'h6' },
      ],
    },
    alignment: {
      type: 'radio',
      label: 'Posisi',
      options: [
        { label: 'Kiri', value: 'left' },
        { label: 'Tengah', value: 'center' },
        { label: 'Kanan', value: 'right' },
      ],
    },
    color: {
      type: 'text',
      label: 'Warna (HEX)',
    },
  },
  render: Heading,
}
